<template>
  <el-dialog v-model="visible" :show-close="false" width="578px" class="add-option-dialog" append-to-body>
    <template #header>
      <div class="drawer-title">
        <div class="drawer-title-content">选项设置</div>
        <div class="drawer-title-icon" @click="close">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </template>
    <div class="option-set">
      <drawer-layout :showCommon="false">
        <template #second>
          <div class="option-set-content">
            <div class="option-set-content-title" style="margin-bottom: 10px;">
              <span style="margin-right: 16px;">标签样式：</span>
              <div class="edit-style" @click="openEditStyle">
                编辑图片样式
              </div>
            </div>
            <div class="option-set-content-title" v-if="!isApp">
              <span style="margin-right: 16px;">高度设置：</span>
              <el-input class="inp" v-model.number="customSize" @change="$set(changeItem, 'customSize', true)">
                <template #suffix>
                  <div style="font-weight: normal;font-size: 12px;">
                    px
                  </div>
                </template>
              </el-input>
            </div>
            <div class="option-set-content-title" style="margin-top: 16px;">
              <span>自定义参数</span>
              <el-dropdown trigger="click" @command="goAdd" style="margin-left: auto;">
                <i class="el-icon-circle-plus-outline"></i>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="custom">自定义</el-dropdown-item>
                    <el-dropdown-item command="variable">表单变量</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="option-set-content-body">
              <div class="link-config" style="height: 273px;">
                <el-scrollbar class="scrollbar">
                  <div v-for="(list, index) in customize" :key="index" class="filter-list">
                    <template v-if="list.type === 'variable'">
                      <el-select style="width: 154px;margin-left: 0;" v-model="list.value" placeholder="请选择" class="filter-list-select nav-select" size="mini">
                        <el-option v-for="(item, itemIndex) in customData" :key="itemIndex" :value="`${item.name}_${item.title}_${item.type}`" :label="item.name" />
                      </el-select>
                    </template>
                    <template v-else>
                      <el-input size="small" type="text" v-model="list.value" style="width: 100px" class="filter-list-input nav-input" placeholder="请输入" />
                    </template>
                    <el-select v-model="list.condition" placeholder="请选择" class="filter-list-select nav-select" size="mini">
                      <el-option v-for="(item, itemIndex) in conditionList" :key="itemIndex" :value="item.value" :label="item.label" />
                    </el-select>
                    <el-select style="flex: 1;" v-model="list.conditionValue" placeholder="请选择" class="filter-list-select nav-select" size="mini">
                      <el-option v-for="(item, itemIndex) in formList" :label="item.name" :key="itemIndex" :value="`${item.title}_${item.type}_${item.name}`" />
                    </el-select>
                    <!-- 删除按钮 -->
                    <i class="WSiconfont WSicon-Delete" @click="delLixt(index)" />
                  </div>
                </el-scrollbar>
                <div v-if="customize.length === 0" class="link-img">
                  <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/Intersect.png" />
                  <div class="text">您还没有添加数据参数哦~</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </drawer-layout>
      <div class="option-set-foot">
        <el-button size="small" @click="close">取消</el-button>
        <el-button type="primary" size="small" @click="confirm">保存</el-button>
      </div>
    </div>
    <editStyle ref="editStyle" :customData="customData" title="编辑图片样式" @on-success="confirmEdit" :modelW="`${editStyleReact.width}px`" :modelH="`${editStyleReact.height}px`" />
  </el-dialog>
</template>

<script>
import drawerLayout from "@/components/admins/instrument/common/container/drawerLayout.vue";
import editStyle from '@/components/common/editStyle/index.vue';
import { cloneDeep } from 'lodash'
export default {
  data() {
    return {
      visible: false,
      customize: [],
      info: {},
      customSize: 60,
      totalConfig: {},
      conditionList: [
        {
          label: '等于',
          value: 'eq'
        }
      ],
      editStyleReact: {},
      isBatch: false,
      changeItem: {}
    }
  },
  props: {
    fieldList: {
      type: Array,
      default: ()=> ([])
    },
    isApp:{
      type: Boolean,
      default: false
    },
  },
  inject: ['parentCustomData'],
  computed: {
    formList() {
      const li = this.fieldList.map(item => {
        return {
          fatherType: item.fatherType || `${item.name}_${item.type}`,
          name: item.name,
          revisabilityName: item.name,
          title: item.title,
          type: item.type
        }
      }).filter(item => ['radio', 'checkbox', 'text', 'textarea', 'number'].includes(item.type))
      return li
    },
    customData() {
      return this.parentCustomData && this.parentCustomData()
    }
  },
  components:{
    drawerLayout,
    editStyle
  },
  methods: {
    open(config = {}, opt = {}) {
      if (config) {
        const data = cloneDeep(config)
        this.customize = data.customize || []
        this.info = data.styleInfo || {}
        this.customSize = data.customSize || 60
        this.totalConfig = data
      }
      const { rect, isBatch } = opt
      this.editStyleReact = rect
      this.isBatch = isBatch
      this.visible = true
    },
    confirmEdit(val, opt = {}){
      const obj = {
        styleInfo: val,
        bgSelect: opt.bgSelect,
      }
      this.info = obj
      this.changeItem.styleInfo = true
    },
    openEditStyle(){
      const { styleInfo, bgSelect = '' } = this.info
      this.$refs.editStyle.open(styleInfo, { bgSelect })
    },
    close() {
      // 重置数据
      const initialData = this.$options.data.call(this)
      Object.assign(this.$data, initialData)
      this.visible = false
    },
    confirm() {
      const obj = {
        ...this.totalConfig,
        styleInfo: this.info,
        customize: this.customize,
        customSize: this.customSize
      }
      this.$emit('confirm', obj, this.changeItem)
      this.visible = false
    },
    goAdd(type) {
      const id = Math.random().toString(36).substr(2, 9)
      const obj = {
        condition: 'eq',
        conditionValue: '',
        value: '',
        id,
        type
      }
      this.customize.push(obj)
      this.changeItem.customize = true
    },
    delLixt(index) {
      this.customize.splice(index, 1)
      this.changeItem.customize = true
    }
  },
}
</script>

<style lang='scss' scoped>
::v-deep.el-dialog__wrapper {
  .add-option-dialog {
    .el-dialog__header {
      padding: 0 16px;
      background: rgba(1, 25, 51, 1);
      .drawer-title {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-content {
          font-size: 14px;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
        }
        &-icon {
          width: 24px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          cursor: pointer;
          .el-icon-close {
            font-size: 12px;
            color: #fff;
          }
        }
      }
      .el-dialog__headerbtn {
        right: 15px;
        top: 12px;
        font-size: 20px;
        color: #bfbfbf;
      }
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}

.option-set {
  height: 100%;
  &-content {
    padding-right: 16px;
    box-sizing: border-box;
    &-title {
      font-weight: bold;
      font-size: 12px;
      line-height: 20px;
      color: #33393e;
      cursor: pointer;
      display: flex;
      align-items: center;
      .edit-style {
        width: 113px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #eeeeee;;
        font-size: 12px;
        cursor: pointer;
      }
      ::v-deep .inp {
        width: 120px;
        height: 32px;
        line-height: 32px;
        .el-input__inner {
          height: 32px;
          line-height: 32px;
        }
      }
      i {
        margin-left: auto;
        font-size: 16px;
        color: #4e86ff;
      }
    }
    &-body {
      .link-config {
        background: #f7fafc;
        border-radius: 4px;
        padding: 16px 0 0 16px;
        margin-top: 16px;
        height: 203px;
        position: relative;
        .link-img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          img {
            width: 71px;
          }
          .text {
            font-size: 12px;
            line-height: 20px;
            text-align: center;
            color: #a9becc;
            padding-top: 16px;
          }
        }
        ::v-deep .scrollbar {
          height: 100%;
          .el-scrollbar__wrap {
            overflow-x: auto;
          }
        }
      }
    }
  }
  &-foot {
    height: 48px;
    background: #fff;
    border-top: solid 1px #e9e9e9;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

::v-deep .el-input__suffix-inner i {
  font-size: 12px;
  color: #adb0b2;
  font-style: inherit;
}

.filter-list {
  padding-bottom: 6px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f4f7;
}

.filter-list-name {
  width: 90px;
  min-width: 90px;
  height: 18px;
  line-height: 18px;
  padding: 6px;
  font-size: 12px;
  margin-right: 6px;
  display: inline-block;
}

::v-deep .filter-list-input {
  flex: 1;
  height: 28px;
  line-height: 28px;
  border-radius: 4px;
  font-size: 12px;
  color: #33393e;
  outline: none;
  box-sizing: border-box;
  vertical-align: top;
  .el-input__inner {
    height: 100%;
    line-height: 28px;
  }
}

.filter-text {
  display: inline-block;
  vertical-align: top;
  margin: 16px 6px;
  font-weight: bolder;
  min-width: 30px;
}

.WSicon-Delete {
  font-size: 16px;
  cursor: pointer !important;
  color: #fd6f5c;
  margin-left: 16px;
}

.filter-list-select {
  vertical-align: top;
  display: inline-block;
  margin-left: 16px;
}

.nav-select {
  width: 82px;
  ::v-deep .el-input__inner {
    background-color: transparent;
    border-color: transparent;
  }
  ::v-deep .el-input__suffix {
    .el-input__icon {
      line-height: 34px;
    }
  }
}

</style>